export { default } from 'features/partners-walmart/routes/walmart-redirect-route';
